import {printStoreReconciliationSheet} from "../network/PrintStoreReconciliationSheetAPI";

export const PrintStoreReconciliationSheetReducer = (state, action) => {
    switch (action.type) {
        case "PRINT_STORE_RECONCILIATION_SHEET":
            const  {driversList, dispatcher} = action.data;
            printStoreReconciliationSheet(driversList, dispatcher);
            return {...state, isOnGoing: true, isSuccess: true};
        case "PRINT_STORE_RECONCILIATION_SHEET_RESPONSE":
            return {...state, isOnGoing: false, isSuccess: true};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/reducers/PrintStoreReconciliationSheetReducer.js